export default "__VITE_ASSET__CfRGN6Ml__"